import _classCallCheck from '@babel/runtime/helpers/esm/classCallCheck';
import _createClass from '@babel/runtime/helpers/esm/createClass';
import { ZeroDecimalCurrenciesEnum, DollarSignCurrenciesEnum } from '@landr/core.models';
import currencyJs from 'currency.js';

var DefaultNumberOfDecimals = 2;
var ZeroNumberOfDecimals = 0;
var Price = /*#__PURE__*/function () {
  function Price() {
    var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    _classCallCheck(this, Price);
    this.value = void 0;
    this.currencyCode = void 0;
    this.currencySymbol = void 0;
    this.discount = void 0;
    this.discountKind = void 0;
    this.kind = void 0;
    this.isCommission = function (currencySymbol) {
      return currencySymbol === '%';
    };
    input = input || {};
    this.value = input.feeValue || input.value;
    this.currencyCode = input.currencyCode;
    this.currencySymbol = input.currencySymbol;
    this.discount = input.discount;
    this.discountKind = input.discountKind;
    this.kind = input.kind;
    if (input.feePolicy) {
      this.kind = input.feePolicy.policyKind;
    }
  }

  /**
   *  This function check if the countryCode match de zeroDecimalCurrencies countries
   *
   * @returns {boolean}
   * @private
   */
  _createClass(Price, [{
    key: "isZeroDecimalCurrency",
    value: function isZeroDecimalCurrency() {
      var Ccode = this.currencyCode ? this.currencyCode : '';
      return Ccode in ZeroDecimalCurrenciesEnum;
    }

    /**
     *  This function check if the currency match the $ sign currencies
     *
     * @returns {boolean}
     * @private
     */
  }, {
    key: "isDollarSignCurrency",
    value: function isDollarSignCurrency() {
      var Ccode = this.currencyCode ? this.currencyCode : '';
      return Ccode in DollarSignCurrenciesEnum;
    }
  }, {
    key: "format",
    value:
    /**
     * Formats a Price with the given options
     * @param hideCurrencyCode Set to false if you want the currency code in the formatted string, e.g. USD $5. Defaulted to true.
     * @param numberOfDecimals The number of decimals to use to format the Price. Defaulted to 2.
     * @param showZeroValueDecimals Show decimals even if they are 0, e.g. $89.00. Defaulted to false.
     * @param decimalMarker String to use as marker for decimals, e.g. ",". Defaulted to ".".
     * @param separatorMarker String to use as marker for separators in long values, e.g. ",". Defaulted to ",".
     */
    function format() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$hideCurrencyCode = _ref.hideCurrencyCode,
        hideCurrencyCode = _ref$hideCurrencyCode === void 0 ? true : _ref$hideCurrencyCode,
        _ref$hideCurrencySymb = _ref.hideCurrencySymbol,
        hideCurrencySymbol = _ref$hideCurrencySymb === void 0 ? false : _ref$hideCurrencySymb,
        _ref$numberOfDecimals = _ref.numberOfDecimals,
        numberOfDecimals = _ref$numberOfDecimals === void 0 ? DefaultNumberOfDecimals : _ref$numberOfDecimals,
        _ref$showZeroValueDec = _ref.showZeroValueDecimals,
        showZeroValueDecimals = _ref$showZeroValueDec === void 0 ? false : _ref$showZeroValueDec,
        _ref$decimalMarker = _ref.decimalMarker,
        decimalMarker = _ref$decimalMarker === void 0 ? '.' : _ref$decimalMarker,
        _ref$separatorMarker = _ref.separatorMarker,
        separatorMarker = _ref$separatorMarker === void 0 ? ',' : _ref$separatorMarker;
      var decimals;
      if (this.isZeroDecimalCurrency()) {
        /**
         * If a numberOfDecimals is provided to the component it will be used,
         * otherwise we determine if is a 0 decimal currency or we let the component decide
         */
        decimals = ZeroNumberOfDecimals;
      } else {
        if (showZeroValueDecimals) {
          // if showZeroValueDecimals is true, simply return the number of decimals
          decimals = numberOfDecimals;
        } else {
          // need to manually set the number of decimal to 0 if the current amount has no decimals and showZeroValueDecimals is set to false
          decimals = this.value % 1 === ZeroNumberOfDecimals ? ZeroNumberOfDecimals : numberOfDecimals;
        }
      }
      var formatOptions = {
        // When formatWithSymbol is set to true, will include the currency symbol when calling currency.format().
        formatWithSymbol: !hideCurrencySymbol,
        decimal: decimalMarker,
        separator: separatorMarker
      };

      // Handle commission
      if (this.isCommission(this.currencySymbol)) {
        formatOptions.symbol = this.currencySymbol;
        formatOptions.precision = ZeroNumberOfDecimals;
        // ! as replacement for the currency symbol and # as replacement for the currency amount.
        // this allows us to display commission percentage with the symbol at the end.
        formatOptions.pattern = '#!';
      } else {
        var currencyCode = "".concat(this.currencyCode, " ");
        formatOptions.precision = decimals;

        /**
         * If hideCurrencyCode is true we only use the currency symbol,
         * Otherwise we only use the currency symbol if the currency is not a $ sign currency
         */
        formatOptions.symbol = hideCurrencyCode || !this.isDollarSignCurrency() ? this.currencySymbol : currencyCode.concat(this.currencySymbol);
      }
      return {
        formattedPrice: currencyJs(this.value, formatOptions).format()
      };
    }
  }]);
  return Price;
}();

export { Price };
